// ----------------------------------------------------------------------------
// Section: Site Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import Swiper, { Navigation, A11y, Keyboard, Autoplay, EffectFade } from 'swiper';
import 'snippets/announcement-bar/announcement-bar';
import 'snippets/menu/menu';
import 'snippets/country-switcher/country-switcher';
import 'snippets/mini-cart/mini-cart'; // TODO: include mini cart here for now.
import 'snippets/smart-cart-template/smart-cart-template';
import 'snippets/search-form/search';
import 'snippets/icon/icon';

// Styles
import './_header.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import 'swiper/css/effect-fade';

// Optional Features
import './header--sticky';


// -------------------------------------
// Variables
// -------------------------------------

var headerClass = '.header';
var menuClass   = '.menu--default';
var menuToggle  = '.header__link--menu';


// -------------------------------------
// Hooks
// -------------------------------------

$(document).ready(function() {

    // Unless we click inside the header,
    // we probably don't want to have open navs
    $('body').on('click', function(event) {
        if (!$(event.target).closest(menuClass).length && !$(event.target).closest('.header__container').length) {
            $(menuToggle).removeClass('js--isOpen');
            $(headerClass).removeClass('js--isOpen');
            $('.menu__item--slider').removeClass('js--isOpen');
            $('.menu__item--mega-nav').removeClass('js--isOpen');
            $(menuClass).removeClass('js--isOpen');
        }
    });

// Open menu on mobile
$(menuToggle).on('click', function(event) {
    event.preventDefault();

    $(this).toggleClass('js--isOpen');
    $(headerClass).toggleClass('js--isOpen');
    $(menuClass).toggleClass('js--isOpen');
    $('.menu__item--slider').removeClass('js--isOpen');
    $('.menu__item--mega-nav').removeClass('js--isOpen');
    $('body').toggleClass('noscroll--header');

    // Check if .header has the js--isOpen class and add header--background if it does
    if ($(headerClass).hasClass('js--isOpen')) {
        $(headerClass).addClass('header--background');
    }
});


    document.addEventListener('keyup', function(e) {
        if (e.key == 27 && $(menuClass).hasClass('js--isOpen') ) {
            $(menuToggle).removeClass('js--isOpen');
            $(headerClass).removeClass('js--isOpen');
            $(menuClass).removeClass('js--isOpen');
            $('.menu__item--slider').removeClass('js--isOpen');
            $('.menu__item--mega-nav').removeClass('js--isOpen');
            $('body').removeClass('noscroll--header');
        }
    });


    // // Header Sticky State
    // $(window).scroll(function(){
    //     if($(window).scrollTop() > 0) {
    //         $('.header').addClass('is-sticky');
    //         $('.announcement-bar').addClass('is-sticky');
    //     }else {
    //         $('.header').removeClass('is-sticky');
    //         $('.announcement-bar').removeClass('is-sticky');
    //     }
    // });


    // Annoucement Bar Slider
    $(".carousel--announcement-bar").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each feature collection slider
        $this.addClass("announcement-bar-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.announcement-bar').find(".swiper-button-next").addClass("announcement-bar-btn-next-" + index);
        $this.parents('.announcement-bar').find(".swiper-button-prev").addClass("announcement-bar-btn-prev-" + index);

        // Initialize feature collection slider based on the unique classes generated above.
        var swiper = new Swiper(".announcement-bar-instance-" + index, {
            // Optional parameters
            modules: [Navigation, A11y, Keyboard, Autoplay, EffectFade],
            slidesPerView: 1,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            keyboard: {
                enabled: false
            },
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
                disableOnInteraction: true
            },
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            speed: 650,
            // Navigation arrows
            navigation: {
                nextEl: ".announcement-bar-btn-next-" + index,
                prevEl: ".announcement-bar-btn-prev-" + index
            }
        });
    });
});

document.addEventListener('scroll', function() {
    const HEADER_SELECTOR = '.header--home';
    const headerSection = document.querySelector(HEADER_SELECTOR);
    const headerBackgroundClass = 'header--background';
    const isOpenClass = 'js--isOpen';
    let st = document.documentElement.scrollTop;

    // Check if the headerSection exists
    if (headerSection) {
        // Only apply the background change if the header does not have the js--isOpen class
        if (!headerSection.classList.contains(isOpenClass)) {
            if (st > 80) {
                headerSection.classList.add(headerBackgroundClass);
            } else {
                headerSection.classList.remove(headerBackgroundClass);
            }
        }
    }
});

document.addEventListener('DOMContentLoaded', () => {
    // Function to hide elements with specific classes
    function hideElements() {
        // Select all elements with the class 'indivator'
        const elementsToHide = document.querySelectorAll('.indivator');

        // Hide each selected element
        elementsToHide.forEach(element => {
            element.style.display = 'none';
        });
    }

    // Call the function to hide elements on page load
    hideElements();

    // Use MutationObserver to watch for dynamically added elements
    const observerCallback = (mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE && (node.matches('.indivator'))) {
                        // Hide newly added elements with the specified classes
                        node.style.display = 'none';
                    }
                });
            }
        }
    };

    // Create and start the observer
    const observer = new MutationObserver(observerCallback);
    observer.observe(document.body, { childList: true, subtree: true });
});
